import React from 'react';
import { checkIfTokenIsPresent } from './helper';
import { Link } from 'react-router-dom';

class App extends React.Component {

    componentWillMount() {

        var searchParams = new URLSearchParams(this.props.location.search);
        console.log('SSO Paramter', searchParams.get('token'));

        if (searchParams.get('token')) {
            this.props.history.push('/Login');
        } else {
            if (checkIfTokenIsPresent()) {
                let groupId = localStorage.getItem('imark-groupId');
                let userId = localStorage.getItem('imark-userId');
                let userType = localStorage.getItem('imark-userType');
                if (userType === "MEMBER" || userId === 3) {
                    this.props.history.push('/Member/MemberData');
                }
                else if (userType === "VENDOR" || groupId === 2) {
                    this.props.history.push('/Vendor');
                }
                else if (userType === "CORPORATE" || groupId === 1) {
                    this.props.history.push('/Corporate/Overview');
                }
            } else {
                this.props.history.push('/Login');
            }
        }
    }

    render() {
        return (
            <div>
                <Link path="/logout">Login to Imark Dashboard</Link>
            </div>
        )
    }
}

export default App;